import { StatisticsDataTypes } from 'components/statistics';
import { PeriodicalUsersStatistics } from 'models/statistics.model';

export const updatePeriodicalUsersStatistics = (
  periodicalUsersStatistics?: PeriodicalUsersStatistics,
): Array<StatisticsDataTypes> => {
  if (!periodicalUsersStatistics) return [];

  return Object.entries(periodicalUsersStatistics).map(([key, value]) => ({
    circleTitle: key,
    value,
  }));
};
